const _temp0 = require("./routes/Dashboard.jsx");
const _temp1 = require("./routes/Home.jsx");
const _temp2 = require("./routes/Registers.jsx");
const _temp3 = require("./routes/SystemInformation.jsx");
const _temp4 = require("./routes/Wifi.jsx");
module.exports = {
  "Dashboard": _temp0,
  "Home": _temp1,
  "Registers": _temp2,
  "SystemInformation": _temp3,
  "Wifi": _temp4
}